import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { SearchStacksForNavigationItem } from "shared/Stack/useSearchStacksForNavigation/gql";

const SpaceliftVcsRepoUsedByNameCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<SearchStacksForNavigationItem>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`/stack/${item.id}`}>{item.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default SpaceliftVcsRepoUsedByNameCell;
